import { types } from "../types/types";

const initialState = {
  loading: false,
  policies: []
};

export const flowAssignmentPolicyReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FLOW_ASSIGNMENT_POLICY_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.FLOW_ASSIGNMENT_POLICY_SET_LIST:
      return { ...state, policies: action.payload };
    default:
      return state;
  }
};
